import style from '../../../styles/Weather/weather_current_conditions'
import Icon from '../Icon'

const Top = ({ forecast }) => {
  const { temperature = '', iconCode = '', wxPhraseLong = '' } = forecast || {}

  return (
    <div className='container-weather-top'>
      <div className='row'>
        <span className='temperature'>{temperature + '°'}</span>
        <Icon style={style} iconCode={iconCode} />
      </div>
      <div className='row'>
        <span className='description'>{wxPhraseLong}</span>
      </div>
      <style jsx>{style}</style>
    </div>
  )
}

export default Top
